import { useLocation } from 'react-router-dom';
import LoginLayout from 'components/Shared/Layout/LoginLayout';
import LoginHeader from 'components/Shared/LoginHeader';
import { useAppSelector } from 'redux/store';
import { ELoginText, EVerificationText } from './Login.types';
import LoginFlow from './components/LoginFlow';
import VerificationFlow from './components/VerificationFlow';

const Login = () => {
  const location = useLocation() as { state: { via: 'PHONE' | 'EMAIL' } };
  const { via } = location.state || {};
  const signInUser = useAppSelector(state => state.authSlice.signInUser);
  return (
    <LoginLayout>
      <LoginHeader
        title={(signInUser ? EVerificationText : ELoginText).TITLE}
        description={
          (signInUser ? EVerificationText : ELoginText)[
            `${via || signInUser?.via.toUpperCase() || 'PHONE'}_DESCRIPTION`
          ]
        }
      />
      {signInUser ? <VerificationFlow /> : <LoginFlow />}
    </LoginLayout>
  );
};

export default Login;
